export { NVSPage as default } from "@nvb/ui";
